import Header from "@/components/echo/Header";
import Hero from "@/components/echo/Hero";
import Features from "@/components/echo/Features";
import Screenshots from "@/components/echo/Screenshots";
import DownloadCTA from "@/components/echo/DownloadCTA";
import Footer from "@/components/echo/Footer";

export default function LandingPage() {
  return (
    <div className="echo-bg min-h-screen relative" data-testid="landing-page">
      <div className="noise-overlay" aria-hidden="true" />
      <div className="relative z-10">
        <Header />
        <main>
          <Hero />
          <Features />
          <Screenshots />
          <DownloadCTA />
        </main>
        <Footer />
      </div>
    </div>
  );
}
